import React from 'react';
import { Link } from 'react-router-dom';

const HowToPlayButton = ({ gameName, className, asset }) => {
    return (
        <Link role='button' to={`/game/${gameName}`}>
            <img src={asset?.ref} className={`game-button ${className ? className : ''}`} alt={asset?.alt} aria-label={asset?.alt} />
        </Link>
    );
};

export default HowToPlayButton;
